import HorizontalAnnotationFlag from '../flags/HorizontalAnnotationFlag';
import eventUtil from '../util/events';
import subpixel from '../util/canvasSubpixelOffset';
import LineTool from './LineTool';

/** Extended Horizontal Tool */
class ExtendedHorizontalTool extends LineTool {

	get flavor() {
		return 'default';
	}

	_getDefaultParams() {
		return {
			id: `extendedHorizontal.${this.flavor}`,
			name: 'Extended Horizontal',
			value: null,
			extendLeft: true,
			extendRight: true,
			isImmediate: true,
			numberOfAnchors: 1,
			style: this.core.getStyle(`tool.extendedHorizontal.${this.flavor}`)
		};
	}

	init(panel, handles = []) {
		this.panel = panel;
		this.path = [];
		this.handle = handles;

		this.state = {};
		this.flags = {};
	}

	isWithin(mousePanel) {
		const handles = this.handle;

		if (handles) {
			const coords = [handles[0].getCoords()];

			if (!coords[0]) return false;
			const tolerance = 10 + this.params.style.width / 2;

			const r1 = {
				x: 0,
				y: coords[0][1] - tolerance / 2,
				width: this.panel.size.width,
				height: tolerance
			};
			const r2 = {
				x: mousePanel[0],
				y: mousePanel[1],
				width: 1,
				height: 1
			};

			return this.intersect(r1, r2);
		}
	}

	render(event) {
		let coords;
		let value;
		if (event) {
			coords = [eventUtil.getMouseFromDomEvent(event)];
		} else {
			coords = [this.handle[0].getCoords()];
		}

		if (this.state.inProgressHandle) {
			value = this.panel.yAxis.primaryScale.invert(
				subpixel.px(coords[0][1])
			);
			this.params.value = value;
		} else {
			value = this.params.value;
		}

		// couldn't find one or more handles
		if (!coords[0]) return;

		const ctx = this.panel.rootToolContext;

		ctx.beginPath();
		ctx.strokeStyle = this.params.style.color;
		ctx.fillStyle = '#FFF';
		ctx.lineWidth = this.params.style.width;

		// regular line segment
		ctx.moveTo(this.panel.size.padding.left, coords[0][1]);
		ctx.lineTo(this.panel.size.width, coords[0][1]);
		ctx.stroke();

		// create/update/delete flag
		if (!isNaN(value)) {
			if (this.flags.horizontalAnnotation) {
				this.flags.horizontalAnnotation.render();
			} else {
				this.flags.horizontalAnnotation = new HorizontalAnnotationFlag(
					{
						panel: this.panel,
						indicator: this,
						id: 'horizontalAnnotation'
					}
				);
				this.flags.horizontalAnnotation.render();
			}
		} else if (this.flags.horizontalAnnotation) {
			this.flags.horizontalAnnotation.remove();
			delete this.flags.horizontalAnnotation;
		} else {
			return; // bad value results in no further attempts to draw
		}

		this.panel.core.onToolRender(this);
	}
}

export default ExtendedHorizontalTool;
